module.exports = __webpack_public_path__ + "img/logo_hodo.edebd5c0.svg";